<template>
  <div :class="['accordion', {'accordion_numbered': index}]">
    <div class="accordion__title" @click="openedItem = !openedItem">
      <span v-if="index" class="accordion__count">{{ itemIndex }}</span>
      <slot name="title"/>
      <span class="accordion__icon">
        <img v-if="openedItem" src="/frontend/assets/img/icons/minus.svg" alt="">
        <img v-else src="/frontend/assets/img/icons/plus.svg" alt="">
      </span>
    </div>
    <transition name="slide">
      <div class="accordion__body" v-if="openedItem">
        <slot name="body" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    index: {
      type: String,
      default: undefined,
    }
  },
  data() {
    return {
      openedItem: this.opened
    }
  },
  computed: {
    itemIndex: function () {
      if (this.index < 10) {
        return `0${this.index}.`;
      } else {
        return  `${this.index}.`;
      }
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
